!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports["kunstmuseum-icons"] = e(require("react")) : t["kunstmuseum-icons"] = e(t.react);
}(this, function (t) {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var o = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        r.d(n, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 1);
  }([function (e, r) {
    e.exports = t;
  }, function (t, e, r) {
    "use strict";

    r.r(e), r.d(e, "Menu", function () {
      return a;
    }), r.d(e, "Search", function () {
      return u;
    }), r.d(e, "Close", function () {
      return c;
    }), r.d(e, "ArrowLeft", function () {
      return f;
    }), r.d(e, "ArrowRight", function () {
      return h;
    }), r.d(e, "ArrowUp", function () {
      return m;
    }), r.d(e, "ArrowDown", function () {
      return g;
    });
    var n = r(0);

    function o() {
      return (o = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var a = function a(t) {
      return n.createElement("svg", o({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2.25px",
        viewBox: "0 0 29 20.25"
      }, t), n.createElement("g", {
        transform: "translate(0 1.125)"
      }, n.createElement("line", {
        x2: "29"
      }), n.createElement("line", {
        x2: "29",
        transform: "translate(0 9.177)"
      }), n.createElement("line", {
        x2: "29",
        transform: "translate(0 18)"
      })));
    };

    function i() {
      return (i = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var u = function u(t) {
      return n.createElement("svg", i({
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2.25px"
      }, t), n.createElement("ellipse", {
        cx: "8.793",
        cy: "8.673",
        rx: "7.668",
        ry: "7.548"
      }), n.createElement("path", {
        d: "M13.495 13.495L21 21"
      }));
    };

    function l() {
      return (l = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var c = function c(t) {
      return n.createElement("svg", l({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        fill: "none",
        stroke: "#000",
        strokeWidth: "2.25px",
        viewBox: "0 0 22.097 22.274"
      }, t), n.createElement("g", {
        transform: "translate(0.796 0.795)"
      }, n.createElement("line", {
        x2: "29",
        transform: "translate(0 20.506) rotate(-45)"
      }), n.createElement("line", {
        x2: "29",
        transform: "translate(0 0.177) rotate(45)"
      })));
    };

    function s() {
      return (s = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var f = function f(t) {
      return n.createElement("svg", s({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        viewBox: "0 0 25 25"
      }, t), n.createElement("path", {
        d: "M25,10.9H6l8.7-8.7L12.5,0L0,12.5L12.4,25l2.3-2.2L6,14.1h19V10.9z"
      }));
    };

    function p() {
      return (p = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var h = function h(t) {
      return n.createElement("svg", p({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        viewBox: "0 0 25 25"
      }, t), n.createElement("path", {
        d: "M0,14.1h19l-8.7,8.7l2.3,2.2L25,12.5L12.5,0l-2.2,2.2l8.7,8.7H0V14.1z"
      }));
    };

    function v() {
      return (v = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var m = function m(t) {
      return n.createElement("svg", v({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        viewBox: "0 0 25 25"
      }, t), n.createElement("path", {
        d: "M14.1,25V6l8.7,8.7l2.2-2.2L12.5,0L0,12.4l2.2,2.3L10.9,6v19H14.1z"
      }));
    };

    function w() {
      return (w = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var r = arguments[e];

          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
          }
        }

        return t;
      }).apply(this, arguments);
    }

    var g = function g(t) {
      return n.createElement("svg", w({
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "1em",
        viewBox: "0 0 25 25"
      }, t), n.createElement("path", {
        d: "M10.9,0v19l-8.7-8.7L0,12.5L12.5,25L25,12.6l-2.2-2.3L14.1,19V0L10.9,0z"
      }));
    };
  }]);
});